document.getElementById('ContactCPF').addEventListener('input', function (e) {
  let value = e.target.value.replace(/\D/g, '');

  if (value.length > 11) {
    value = value.slice(0, 11);
  }

  value = value.replace(/(\d{3})(\d)/, '$1.$2');
  value = value.replace(/(\d{3})(\d)/, '$1.$2');
  value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

  e.target.value = value;
});

document.getElementById('ContactNumber').addEventListener('input', function (e) {
  let value = e.target.value.replace(/\D/g, '');

  if (value.length > 11) {
    value = value.slice(0, 11);
  }

  if (value.length > 10) {
    value = value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else {
    if (value.length <= 7)
      value = value.replace(/(\d{2})(\d)/, '($1) $2');

    value = value.replace(/(\d{2})(\d{4})(\d)/, '($1) $2-$3');
    value = value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }

  e.target.value = value;
});

const statesUfs = {
  "ACRE": "ac",
  "ALAGOAS": "al",
  "AMAPÁ": "ap",
  "AMAZONAS": "am",
  "BAHIA": "ba",
  "CEARÁ": "ce",
  "DISTRITO FEDERAL": "df",
  "ESPÍRITO SANTO": "es",
  "GOIÁS": "go",
  "MARANHÃO": "ma",
  "MATO GROSSO": "mt",
  "MATO GROSSO DO SUL": "ms",
  "MINAS GERAIS": "mg",
  "PARÁ": "pa",
  "PARAÍBA": "pb",
  "PARANÁ": "pr",
  "PERNAMBUCO": "pe",
  "PIAUÍ": "pi",
  "RIO DE JANEIRO": "rj",
  "RIO GRANDE DO NORTE": "rn",
  "RIO GRANDE DO SUL": "rs",
  "RONDÔNIA": "ro",
  "RORAIMA": "rr",
  "SANTA CATARINA": "sc",
  "SÃO PAULO": "sp",
  "SERGIPE": "se",
  "TOCANTINS": "to"
};

const handleContactStateSelector = async () => {
  const selectedState = document.getElementById("ContactState")?.value;
  if (!selectedState) return

  const citySelectorElement = document.getElementById("ContactCity");
  citySelectorElement.disabled = false;

  const url = `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${statesUfs[selectedState]}/municipios`

  citySelectorElement.innerHTML = '<option selected value="" disabled>Cidade</option>';
  citySelectorElement.value = '';

  try {
    const response = await fetch(url);
    const cities = await response.json();

    for (const city of cities) {
      citySelectorElement.innerHTML += `<option value="${city.nome}">${city.nome}</option>`
    }
  } catch (err) {
    console.error(err)
  }
}